import { HeadTag } from './head-tag'

export default HeadTag
